/**
 * Recursively parses stringified JSON object values inside a given object.
 */
export function deepParse(str: string) {
  try {
    const parsed = JSON.parse(str);
    if (typeof parsed === "object" && parsed !== null) {
      for (const key in parsed) {
        if (typeof parsed[key] === "string") {
          parsed[key] = deepParse(parsed[key]);
        }
      }
    }
    return parsed;
  } catch (e) {
    return str;
  }
}
